import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const client = axios.create({ baseURL: `${API_URL}/api/assess` });

const assessmentService = {
  start: async (sessionId) => {
    const res = await client.post('/start', { session_id: sessionId });
    return res.data;
  },

  chat: async (sessionId, message, state, transcript) => {
    const res = await client.post('/chat', {
      session_id: sessionId,
      message,
      state,
      transcript,
    });
    return res.data;
  },
};

export default assessmentService;
